<template>
  <div class="modal-panel">
    <div class="cropper-select">
      <cropper
        class="cropper"
        :src="img"
        ref="cropper"
        :stencil-props="{
          aspectRatio: 10 / 10,
        }"
        @change="change"
      ></cropper>
    </div>
    <v-row>
      <v-col cols="12" sm="2"> </v-col>
      <v-col cols="12" sm="8" class="btn-center">
        <v-btn @click="onDone" class="right-btn cust-btn" color="primary">Done</v-btn>
        <v-btn
          @click="onClose({ status: false })"
          class="right-btn cust-btn"
          color="primary"
          >Cancel</v-btn
        >
      </v-col>
      <v-col cols="12" sm="2"> </v-col>
    </v-row>
  </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
export default {
  name: "UploadProfilePic",
  props: ["onClose", "data"],
  components: {
    Cropper,
  },
  data() {
    return {
      img: this.data.img_url,
    };
  },
  methods: {
    change({ coordinates, canvas }) {
      //this.base64Image = canvas.toDataURL('image/jpeg');
    },
    async onDone() {
      let result = this.$refs.cropper.getResult();
      let base64Image = result.canvas.toDataURL("image/jpeg");
      let blob = await this.getBlob(result.canvas);
      this.onClose({ status: false, data: { base64Image, blob } });
    },
    getBlob(canvas) {
      return new Promise((resolve, reject) => {
        canvas.toBlob(
          blob => {
            blob.name = "newFile.jpeg";
            resolve(blob);
          },
          "image/jpeg",
          1
        );
      });
    },
  },
  watch: {
    data(val) {
      this.img = this.data.img_url;
    },
  },
};
</script>

<style lang="scss">
.cropper-select {
  padding: 60px 60px 10px 60px;
  .cropper {
    height: 350px;
    background: #ddd;
  }
}
</style>
